import { Component, inject, OnInit, signal } from '@angular/core';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { WorkTeam, WorkTeamsV2Service } from '@work-frontend-monorepo/work-rest-api';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import dayjs from 'dayjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@work-frontend-monorepo/work-ui/layout';
import { MontageplanDayOverviewComponent } from '@work-frontend-monorepo/work-ui/helpers';
import { InputDatepickerComponent } from '@work-frontend-monorepo/work-ui/forms';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';

@Component({
  selector: 'sfg-app-montageplan-uebersicht-page',
  templateUrl: './montageplan-uebersicht-page.component.html',
  styleUrls: ['./montageplan-uebersicht-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonMenuButton,
    IonButtons,
    IonBackButton,
    TranslatePipe,
    ButtonComponent,
    MontageplanDayOverviewComponent,
    InputDatepickerComponent,
  ],
})
export class MontageplanUebersichtPageComponent implements OnInit {
  private readonly workTeamsV2Service = inject(WorkTeamsV2Service);
  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly router = inject(Router);

  protected selectedDate = signal(dayjs().format('YYYY-MM-DD'));
  protected teamsAll = signal<WorkTeam[]>([]);

  async ngOnInit() {
    await this.loadTeams();
  }

  protected goToPreviousDay() {
    this.selectedDate.set(dayjs(this.selectedDate()).subtract(1, 'day').format('YYYY-MM-DD'));
  }

  protected goToNextDay() {
    this.selectedDate.set(dayjs(this.selectedDate()).add(1, 'day').format('YYYY-MM-DD'));
  }

  protected onDateChange(date: string | null) {
    if (date) {
      this.selectedDate.set(date);
    }
  }

  protected async openProjectDetails(projectId: number) {
    await this.router.navigate(['mitarbeitende', 'projekte', 'details', projectId], { queryParams: { date: this.selectedDate() } });
  }

  protected async openUserDetails(userId: number) {
    await this.router.navigate(['mitarbeitende', 'adressbuch', 'details', userId]);
  }

  private async loadTeams() {
    try {
      const paginatedTeams = await lastValueFrom(
        this.workTeamsV2Service.teamsV2ControllerFindAllPaginated({ limit: 1000 }),
      );
      this.teamsAll.set(paginatedTeams.data);
    } catch (loadTeamsException) {
      this.exceptionHandlingService.handleExceptionWithAlert('loadTeamsException', loadTeamsException);
    }
  }
}
